export const onAddItem = (id, dist) => ({
  widget: 'models',
  type: 'onAddItem',
  payload: { id, dist },
})



// WEBPACK FOOTER //
// ./src/models/actions/onAddItem.js